import React, { Component } from "react";
import { withRouter, Route } from "react-router-dom";
import { connect } from "react-redux";

//modal
import ModalAlertComponent from "../../Components/modal/ModalSmall";

class ModalSmallContainer extends Component {
  constructor() {
    super();
    this.state = {
      showModal: true
    };
  }

  render() {
    return (
      <div>
        <ModalAlertComponent
          visible={this.state.showModal} //true를 넘기면 팝업이 열리고 false를 넘기면 닫힘
          topContent={
            <img
              src={
                "https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-alert.svg"
              }
            ></img>
          } //top contents
          middleContent={"인증 만료된 제품입니다"} //middle contents
          bottomContent={
            //bottom contents
            <React.Fragment>
              <span>
                자세한 사항은 고객센터로
                <br />
                문의 부탁드립니다
              </span>
            </React.Fragment>
          }
          confirmFont={"확인"} //기본값 "확인" 값을 넘기면 해당 글자가 버튼에 표시
          onConfirm={() => {
            // 버튼 누를시 이벤트 선언
            this.setState({
              showModal: false
            });
          }}
        ></ModalAlertComponent>
      </div>
    );
  }
}

export default connect()(withRouter(ModalSmallContainer));
